import _Math$trunc from '/var/www/html/node_modules/babel-runtime/core-js/math/trunc';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import $ from 'jquery';
import axios from 'axios';

export default {
  props: ['title', 'placeholder', 'type'],
  data: function data() {
    return {
      errorMessage: '',
      placeHolderMessage: '',
      geoCountryCode: '',
      view: 'default'
    };
  },

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang;
    }
  },
  mounted: function mounted() {
    this.counter();

    this.placeHolderMessage = this.$root.trans(this.placeholder);

    if (this.type == 'phone') {
      this.loadPhoneInput();
    }
  },
  created: function created() {
    if (process.client) {
      this.geoIpLookup(function (countryCode) {
        this.geoCountryCode = countryCode;
      }.bind(this));
    }
    this.view = global.getTheme();
  },

  methods: {
    counter: function counter() {
      var counters = document.querySelectorAll('#statistics-counter');
      var speed = 800;
      counters.forEach(function (counter) {
        var updateCount = function updateCount() {
          var target = parseInt(+counter.getAttribute("data-target"));
          var count = parseInt(+counter.innerText);
          var increment = _Math$trunc(target / speed);
          if (count < target) {
            counter.innerText = count + increment;
            setTimeout(updateCount, 1);
          }
        };
        updateCount();
      });
    },
    search: function search() {
      if (this.type == 'phone' && this.validatePhoneInput() || this.validateSearchInput()) {
        if (this.type == 'phone') {
          var phoneNumber = $(".phone-number").intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
          $(".phone-number").val(phoneNumber);
        }

        //sessionStorage.setItem('lastSearchText', $('#search_input').val());
        //sessionStorage.setItem('lastSearchType', this.getSearchType());


        customSessionStorage.setItem('lastSearchText', $('#search_input').val());
        customSessionStorage.setItem('lastSearchType', this.getSearchType());

        this.$router.push({
          name: 'lang-search-results-type-search-loading',
          params: {
            lang: this.$route.params.lang,
            search: $('#search_input').val(),
            type: this.getSearchType()
          }
        });
      }
    },
    storeInvalidSearchKeyword: function storeInvalidSearchKeyword() {
      if ($('#search_input').val() != '') {
        axios.get(global.getEndPoint() + 'api/create-fake-query?search_keyword=' + $('#search_input').val() + '&validation_status=0&search_type=' + this.type).then(function (res1) {});
      }
    },
    validatePhoneInput: function validatePhoneInput() {
      var isValid = $("#search_input").intlTelInput("isValidNumber");
      if (isValid) {
        return true;
      } else {
        this.errorMessage = this.$root.trans('st_public.invalid_phone_number');
      }
      this.storeInvalidSearchKeyword();
      return false;
    },
    validateSearchInput: function validateSearchInput() {
      this.errorMessage = '';
      var searchText = $("#search_input").val();
      if (!searchText.length) {
        this.errorMessage = this.$root.trans('st_public.empty_search_text');
      } else {
        if (this.getSearchType() == 'phone') {
          if (intlTelInputUtils.isValidNumber(searchText, this.geoCountryCode)) {
            $("#search_input").val(intlTelInputUtils.formatNumber(searchText, this.geoCountryCode, intlTelInputUtils.numberFormat.INTERNATIONAL));
            return true;
          } else {
            this.errorMessage = this.$root.trans('st_public.invalid_phone_number');
          }
        } else if (this.getSearchType() == 'name') {
          var nameParts = searchText.replace(/^[\s]+|[\s]+$/g, '').split(" ");
          if (nameParts.length >= 2) {
            return true;
          } else {
            this.errorMessage = this.$root.trans('st_public.you_have_to_provide_first_and_lastname');
          }
        } else if (this.getSearchType() == 'email') {
          var emailRegExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
          if (emailRegExp.test(searchText)) {
            return true;
          } else {
            this.errorMessage = this.$root.trans('st_public.invalid_email_address');
          }
        }
      }
      this.storeInvalidSearchKeyword();
      return false;
    },
    getSearchType: function getSearchType() {
      var searchText = $("#search_input").val();
      if (searchText.match(/@/)) {
        return 'email';
      } else if (searchText.match(/^[0-9\(\) \+\-]+$/g)) {
        return 'phone';
      } else {
        return 'name';
      }
    },
    geoIpLookup: function geoIpLookup(callback) {
      axios.get(global.getEndPoint() + 'api/common/geo-country').then(function (res) {
        var countryCode = res.data.country;
        callback(countryCode);
      });

      /*
      $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
          var countryCode = (resp && resp.country) ? resp.country : "";
          callback(countryCode);
      });
       */
    },
    loadPhoneInput: function loadPhoneInput() {
      if (process.client) {
        require('intl-tel-input');

        $(".phone-number").intlTelInput({
          initialCountry: 'auto',
          geoIpLookup: this.geoIpLookup
          //, utilsScript: "/js/utils.js"
        });

        //$('.flag-container').css('left', 0);
        //$('.flag-container').css('right', 'auto');
        //$('.selected-flag').css('padding', '0 0 0 8px');
        //$('.iti-arrow').css('left', 'auto');
        //$('.iti-arrow').css('right', '6px');
        //$('.country-list').css('direction', 'ltr');
        //$('.country-list').css('text-align', 'left');
        //$('.phone-number').css('padding-left', '52px');
        //$('.phone-number').css('padding-right', '6px');
        //$('.phone-number').css('text-align', this.lang=='ar'?'left':'right');
        $('.phone-number').css('direction', 'ltr');
        $('.intl-tel-input').addClass('form-control-lg');
        $('.intl-tel-input').addClass('form-control');
        $('.intl-tel-input').addClass('border');
        $('.intl-tel-input').addClass('border-primary');
        $('.intl-tel-input').css('padding', 0);
        $('.intl-tel-input .form-control').css('border', 0);

        var lng = this.lang;
        $(".phone-number").on("open:countrydropdown", function (e, countryData) {
          $('.country-list').css('direction', 'ltr');
          if (lng == 'ar') {
            $('.flag-box').css('float', 'right');
            $('.flag-box').css('margin-top', '5px');
          }
        });
      }
    },

    websiteName: function websiteName() {
      var displayName = global.websiteSettings.extra_info.display_name;
      if (displayName) {
        return this.$root.trans('st_public.' + displayName);
      }
      return '';
    }

  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/SearchBox.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/SearchBox.vue
// module chunks = 2 3 4 5 6 7